/**
 * @generated SignedSource<<5da5a0d84638227eee64dcbc801c26ff>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DeleteMatchInput = {
  clientMutationId?: string | null | undefined;
  rowId: any;
};
export type useUnmatchMutation$variables = {
  input: DeleteMatchInput;
};
export type useUnmatchMutation$data = {
  readonly deleteMatch: {
    readonly query: {
      readonly currentUser: {
        readonly " $fragmentSpreads": FragmentRefs<"MessagesView_user">;
      } | null | undefined;
      readonly currentUserUnreadCount: number | null | undefined;
    } | null | undefined;
  } | null | undefined;
};
export type useUnmatchMutation = {
  response: useUnmatchMutation$data;
  variables: useUnmatchMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "currentUserUnreadCount",
  "storageKey": null
},
v3 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 20
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useUnmatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeleteMatchPayload",
        "kind": "LinkedField",
        "name": "deleteMatch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "MessagesView_user"
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useUnmatchMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "DeleteMatchPayload",
        "kind": "LinkedField",
        "name": "deleteMatch",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Query",
            "kind": "LinkedField",
            "name": "query",
            "plural": false,
            "selections": [
              (v2/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "User",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": (v3/*:: as any*/),
                    "concreteType": "ConversationConnection",
                    "kind": "LinkedField",
                    "name": "conversations",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ConversationEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "cursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Conversation",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Match",
                                "kind": "LinkedField",
                                "name": "match",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "rowId",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Profile",
                                    "kind": "LinkedField",
                                    "name": "profile",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "name",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "kind": "ScalarField",
                                        "name": "closestCity",
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "Photo",
                                        "kind": "LinkedField",
                                        "name": "headshot",
                                        "plural": false,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "StorageObject",
                                            "kind": "LinkedField",
                                            "name": "storageObject",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "blurhash",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "bucket",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "key",
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          },
                                          (v4/*:: as any*/)
                                        ],
                                        "storageKey": null
                                      },
                                      (v4/*:: as any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "unreadCount",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Message",
                                "kind": "LinkedField",
                                "name": "lastMessage",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "createdAt",
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "kind": "ScalarField",
                                    "name": "title",
                                    "storageKey": null
                                  },
                                  (v4/*:: as any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__typename",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "endCursor",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "hasNextPage",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": "conversations(first:20)"
                  },
                  {
                    "alias": null,
                    "args": (v3/*:: as any*/),
                    "filters": null,
                    "handle": "connection",
                    "key": "MessagesView_user_conversations",
                    "kind": "LinkedHandle",
                    "name": "conversations"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unviewedMatchMessagesCount",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "unviewedSystemMessagesCount",
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              },
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "65ce6629390e70783b120ddf85f6df90",
    "id": null,
    "metadata": {},
    "name": "useUnmatchMutation",
    "operationKind": "mutation",
    "text": "mutation useUnmatchMutation(\n  $input: DeleteMatchInput!\n) {\n  deleteMatch(input: $input) {\n    query {\n      currentUserUnreadCount\n      currentUser {\n        ...MessagesView_user\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment MessagesViewMatchItem_conversation on Conversation {\n  match {\n    rowId\n    profile {\n      name\n      closestCity\n      ...ProfileListItem_profile\n      id\n    }\n    id\n  }\n  unreadCount\n}\n\nfragment MessagesViewSystemItem_conversation on Conversation {\n  lastMessage {\n    createdAt\n    title\n    id\n  }\n  unreadCount\n}\n\nfragment MessagesView_user on User {\n  conversations(first: 20) {\n    edges {\n      cursor\n      node {\n        type\n        ...MessagesViewMatchItem_conversation\n        ...MessagesViewSystemItem_conversation\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n  unviewedMatchMessagesCount\n  unviewedSystemMessagesCount\n  id\n}\n\nfragment ProfileAvatar_profile on Profile {\n  headshot {\n    storageObject {\n      blurhash\n      bucket\n      key\n    }\n    id\n  }\n  name\n}\n\nfragment ProfileListItem_profile on Profile {\n  name\n  ...ProfileAvatar_profile\n}\n"
  }
};
})();

(node as any).hash = "7e2b497b570db8f62359c1a9626422ba";

export default node;
